import styled from "styled-components";

import colors from "@src/common/styles/colors";
import {
  DEFAULT_MARGIN_M,
  DEFAULT_MARGIN_S,
  DEFAULT_MARGIN_XS,
} from "@src/common/styles/const";
import { wrapLongText } from "@src/common/styles/mixins";
import { ReactComponent as Close } from "@src/modules/shared/components/FileInput/icons/close.svg";

export const FileInputWrapper = styled.div`
  overflow: hidden;
`;

export const FileInputHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LoadedFile = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  padding: ${DEFAULT_MARGIN_S}px;
  border-radius: 6px;
  background-color: ${colors.white};
`;

export const FileName = styled.span`
  font-size: 12px;
  line-height: 17px;
  color: ${colors.gray3};
  ${wrapLongText}
`;

export const LoadedFilesWrapper = styled.div`
  margin-top: ${DEFAULT_MARGIN_M}px;
  padding: 0 ${DEFAULT_MARGIN_XS}px;

  ${LoadedFile} + ${LoadedFile} {
    margin-top: ${DEFAULT_MARGIN_XS}px;
  }
`;

export const CloseIcon = styled(Close)`
  cursor: pointer;
`;

export const LoaderWrapper = styled.span`
  display: flex;
  align-items: center;
`;
